window.siteKey = document.querySelector('script[data-recaptcha]').getAttribute('data-recaptcha');

function renderGoogleInvisibleRecaptcha(forms, promise = false, manualInit = false) {
    return new Promise((resolve, reject) => {
        let formsRecaptcha = document.forms;
        if(forms) {
            formsRecaptcha = forms;
        }
        
        for(let i = 0; i < formsRecaptcha.length; ++i) {
            const form = formsRecaptcha[i];
            const holder = form.querySelector('.recaptcha-holder');
            const submitBtn = form.querySelector('button[type=submit]');
            
            if(null === holder) {
                continue;
            }
            
            if(form.classList.contains("recaptchaExcludeAuto") && !manualInit) {
                continue;
            }
            
            if(submitBtn && submitBtn.disabled) {
                submitBtn.disabled = false;
            }
            
            const holderId = grecaptcha.render(holder, {
                'sitekey': window.siteKey,
                'size': 'invisible',
                'badge': 'bottomright', // possible values: bottomright, bottomleft, inline
                'callback': function(recaptchaToken) {
                    if(promise) {
                        if(recaptchaToken) {
                            resolve(recaptchaToken);
                        } else {
                            reject('Recaptcha token failed');
                        }
                        
                        return;
                    }
                    
                    form.submit();
                }
            });
            
            form.onsubmit = function(e) {
                e.preventDefault();
                grecaptcha.execute(holderId);
            };
        }
    });
    
}
